import { render, staticRenderFns } from "./DeletedChange.vue?vue&type=template&id=174f53f0&"
import script from "./DeletedChange.vue?vue&type=script&lang=js&"
export * from "./DeletedChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports